var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root vacancy-unavailable-chat-message"},[_c('div',{staticClass:"message-container"},[_c('div',{staticClass:"info"},[_c('div',[_vm._v(_vm._s(_vm.message.body))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }